import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CsvExportService {
	constructor() {}

	downloadCsvFile(fileName: string, headers: Array<string>, content: Array<Array<string>>) {
		// Create a copy of content to avoid modifying the original array
		const csvRows = [headers, ...content];

		// Escape fields that contain commas, quotes, or newlines
		const escapeCsvField = (field: string): string => {
			if (field == null) return '';
			const stringField = String(field);
			// If field contains comma, quote, or newline, wrap in quotes and escape internal quotes
			if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
				return `"${stringField.replace(/"/g, '""')}"`;
			}
			return stringField;
		};

		const csvContent = csvRows
			.map(row => row.map(escapeCsvField).join(','))
			.join('\n');

		// Use Blob for better compatibility with large files and special characters
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', `${fileName}.csv`);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();

		// Cleanup
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}
}
